import { get } from "lodash";

const styles = (theme) => ({
  content: {
    margin: 36,
    minHeight: 'calc(100vh - 125px)',
    backgroundColor: get(theme, 'color.uiBackground'),
    marginTop: 0,
    padding: '24px 0px 36px 0px',
    '& button': {
      '&:focus': {
        outlineWidth: '1px !important',
        outlineOffset: '1px !important',
      },
    },
  },
  fieldContainer: {
    width: '520px',
  },
  flexNonBetween: {
    display: 'flex',
    alignItems: 'center',
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  editIconButton: {
    fill: get(theme, 'color.primaryButtonBackground'),
    minWidth: 0,
    width: 35,
    height: 35,
    padding: 0,
    marginLeft: "1rem",
    marginTop: "1rem",
  },
  apiGroupName: {
    wordWrap: 'break-word',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '90%',
  },
  apiGroupNameContainer: {
    width: "40%",
  },
  nameContainer: {
    marginTop: -13,
  },
  headerContainer: {
    marginTop: "-1rem",
  },
  gridContainer: {
    display: 'inline-flex',
    width: '100%',
    paddingLeft: 36,
    marginTop: "1rem",
  },
  divider: {
    backgroundColor: get(theme, 'color.bodyText'),
  },
  bodyContent: {
    display: 'block',
  },
  contentPadding: {
    padding: '0px 36px',
  },
  detailsHeading: {
    textTransform: 'capitalize',
    marginTop: '3rem',
  },
  apiGroupdescription: {
    width: 630,
  },
  deleteButton: {
    color: get(theme, 'color.error'),
    borderColor: get(theme, 'color.error'),
  },
  textError: {
    color: get(theme, 'color.error'),
  },
  alertMessagesContainer: {
    marginLeft: 0,
    width: "93% !important",
  },
  status: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    gap: '4px',
    '&:before': {
      content: '""',
      width: '13px',
      height: '13px',
      borderRadius: '50%',
    },
  },
  warning: {
    '&:before': {
      backgroundColor: get(theme, 'color.warning'),
    },
  },
  success: {
    '&:before': {
      backgroundColor: get(theme, 'color.success'),
    },
  },
  statusButton: {
    marginLeft: "1rem",
  },
})

export default styles;